import { Country } from '@afterpay/types'

export const COUNTRIES_WITHOUT_PAYMENT_TYPES_TERMS: Country[] = [Country.AU]
